
// 插件路由
const sendcoupons = () => import(/* webpackChunkName: "sendcoupons" */ '~/addon/sendcoupons/pages/sendcoupons.vue')

const routes = [
	{
        path: '/sendcoupons',
        component: sendcoupons
    },
]

export default routes;



// WEBPACK FOOTER //
// ./src/addon/sendcoupons/router/index.js